import { useSelector } from "react-redux";
import useFormStatus from "./Status";
import { selectIsAdmin } from "../../../services/authorization/slices";
import { FORM_STATUS_LABELS, FORM_STATUSES } from "../../../util/constants";
import { useUpdateFormStatusMutation } from "../../../services/form/api";
import { useState } from "react";
import { useParams } from "react-router-dom";

function useFormStatusChanger() {
    const { type, id } = useParams();
  const { key: currentStatus } = useFormStatus()
  const isAdmin = useSelector(selectIsAdmin)
  const [updateStatus, mutatedStatusResponse] = useUpdateFormStatusMutation()
  const [showConfirmation, setShowConfirmation] = useState({ from: "", to: '' });
  const statusFromApiResponse = mutatedStatusResponse?.data?.formStatus
  
  const changeStatus = (newStatus) => {
    setShowConfirmation({
      from: FORM_STATUS_LABELS?.[currentStatus] || currentStatus,
      to: FORM_STATUS_LABELS?.[newStatus] || newStatus
    })
    updateStatus({
      formType: type, 
      identifier: id, 
      status: newStatus
    })
    return mutatedStatusResponse
  }

  const response = {
    isAllowed: isAdmin,
    canChangeTo: [],
    isLoading: mutatedStatusResponse?.isLoading,
    isError: mutatedStatusResponse?.isError,
    isSuccess: mutatedStatusResponse?.isSuccess && showConfirmation?.to && showConfirmation?.from,
    changeStatus,
    showConfirmation, 
    setShowConfirmation,
    status: statusFromApiResponse || currentStatus || "",
  }
  response.label = FORM_STATUS_LABELS?.[response.status] || response.status

  if(!response.isAllowed) {
    return response
  }
  const standard = [
    FORM_STATUSES.DRAFT,
    FORM_STATUSES.SUBMITTED,
    FORM_STATUSES.REPORTED_ED_1,
    FORM_STATUSES.REPORTED_ED_2,
    FORM_STATUSES.DELETED,
  ]
  const possibleNewStatusOptions = {
    [FORM_STATUSES.DELETED]: [FORM_STATUSES.DRAFT],
    [FORM_STATUSES.SUBMITTED]: standard,
    [FORM_STATUSES.REPORTED]: standard,
    [FORM_STATUSES.REPORTED_ED_1]: standard,
    [FORM_STATUSES.REPORTED_ED_2]: standard,
  }
  response.canChangeTo = possibleNewStatusOptions?.[currentStatus] || []
  response.isAllowed = currentStatus && !!response.canChangeTo?.length
  
  return response
}

export default useFormStatusChanger;
